// extracted by mini-css-extract-plugin
export var fadeInOut = "_4l-3";
export var icon = "_4l-4";
export var savedIndicator = "_4l-2";
export var savingIndicator = "_4l-0";
export var spin = "_4l-1";